import React from 'react';
import styled from 'styled-components';
import Img from 'gatsby-image';
import { useIntersection } from 'hooks';
import { motion } from 'framer-motion';
import { useStaticQuery, graphql } from 'gatsby';

export default () => {
  const data = useStaticQuery(graphql`
    query {
      iphaForumImage: file(relativePath: { eq: "assets/images/ipha-forum.png" }) {
        childImageSharp {
          fluid(maxWidth: 800, quality: 90) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      itransformImage: file(relativePath: { eq: "assets/images/itransform.png" }) {
        childImageSharp {
          fluid(maxWidth: 800, quality: 90) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      genseqImage: file(relativePath: { eq: "assets/images/genseq-live.png" }) {
        childImageSharp {
          fluid(maxWidth: 800, quality: 90) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `);
  const { observerEntry, elRef } = useIntersection({ threshold: 0.25 });
  return (
    <Cases
      initial={{ opacity: 0, y: 50 }}
      animate={observerEntry.isIntersecting ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
      transition={{ duration: 0.25 }}
      ref={elRef}>
      <Case href="https://www.iphaforum.ie/" target="blank">
        <Img
          fluid={data.iphaForumImage.childImageSharp.fluid}
          alt="IPHA Forum Series 2021"
        />
        <h4>IPHA Forum Series 2021</h4>
        <h5>IPHA</h5>
      </Case>
      <Case href="https://itransform2022.netlify.app/" target="blank">
        <Img
          fluid={data.itransformImage.childImageSharp.fluid}
          alt="iTransform 2022"
        />
        <h4>iTransform 2022</h4>
        <h5>Pfizer</h5>
      </Case>
      <Case href="https://genseqlive.com/" target="blank">
        <Img
          fluid={data.genseqImage.childImageSharp.fluid}
          alt="GenseqLive"
        />
        <h4>GenseqLive</h4>
        <h5>Genseq</h5>
      </Case>
    </Cases>
  );
};

const Cases = styled(motion.div)`
  transition: 0.75s;
  grid-column: 1/6;
  display: grid;
  grid-column-gap: 1.25rem;
  grid-row-gap: 2.5rem;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  @media (min-width: 1150px) {
    grid-column: 2/12;
  }
`;

const Case = styled.a`
  display: flex;
  flex-direction: column;
  h4,
  h5 {
    font-size: 1.25rem;
    line-height: 1.25rem;
    text-align: left;
    @media (min-width: 1150px) {
      font-size: 1.5rem;
      line-height: 1.25rem;
    }
  }
  h4 {
    color: var(--ex-main);
    margin-top: 1rem;
    margin-bottom: 0.55rem;
    line-height: 1.25em;
  }
  h5 {
    color: black;
    font-weight: normal;
    margin-bottom: 0.5rem;
  }
`;
